import { createContext } from 'react';

export const defaultFlightData = {
  allData: undefined, // Large flight data object
  allFlights: [], // All flights for user
  cif: '', // CIF data for a flight
  ctot: '', // CTOT data for a flight
  ctotCrew: null, // Detailed CTOT data from GetCTOT_Crew
  ctotHasChanged: false, // Indicator if CTOT has changed and not been acknowledged
  flightInfoCrew: undefined, // Info for crew of a flight
  status: '',
  selectedFlightId: '', // The id of the selected flight
  isCabinCrew: false, // Is the user cabin crew
  isTrainingMode: false, // Is training/simulator mode active
  airports: [],
  airportSelected: null,
  reqFuel: 0,
  taf: [],
  metar: [],
  snowtam: [],
  notam: {}, // NOTAM data per airport ICAO
  areaMessages: [],
  preFlightBriefing: null,
  preFlightBriefingIsNew: false,
  dataFetchTimestamp: undefined,
  tkofSettings: undefined,
  passengerList: [],
  seatmap: [],
  bagList: { checkedInCount: 0, loadedCount: 0, bags: [] },
  ofpFiles: [],
  ofpFuelResetNotice: "",
};

const stub = () => {
  throw new Error('You forgot to wrap your component.');
};

const initialContext = {
  flightData: defaultFlightData,
  changeReqFuel: stub,
  refreshAllData: stub,
  changeFlight: stub,
  changeAirport: stub,
  getAirportsSNOWTAM: stub,
  refreshSeatmapData: async () => stub,
  saveMealModeData: stub,
  getMealModeData: async () => stub,
  getBagList: async () => stub,
  acknowledgeCtotChange: async () => stub,
  dismissOfpFuelResetNotice: stub,
  reinitialize: async () => stub,
  getNOTAMByICAO: async () => stub,
  acknowledgePreFlightBriefing: stub,
  flightListSyncId: 0,
};

export const DataServiceContext = createContext(initialContext);
